export default "__VITE_ASSET__21c74804__"